package ru.malygin.dataConverter

import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.TimeDetectorItem

class MainScheduleComponents(
    private val item: MainScheduleItemDto,
    val timeDetectorItem: TimeDetectorItem
) {
    private val noData = "(❁´◡`❁)"
    private val simpleNoData = "..."
    private val questionMark = "?"
    val noDataText = "Нет данных"



    private val timeRet = when{


        item.lessonStart.isNullOrEmpty() && item.lessonEnd.isNullOrEmpty() -> listOf(noData)

        else -> {
            listOf(item.lessonStart?:questionMark, item.lessonEnd?:questionMark)
        }
    }

    /**
     * Возвращает строку со временем
     *
     * @return listOf(11:00, 12:00) или listOf(?,?) или listOf((❁´◡`❁))
     */
    fun getTimeAll() = timeRet


    /**
     * Возвращает номер аудитории
     *
     * @return "325" или NULL
    */
    fun getRoomNumber() = this.item.roomNum

    /**
     * Возвращает название предмета
     *
     * @return "Мат. анализ" или NULL
     */
    fun getLessonName() = this.item.lessonName

    /**
     * Возвращает имя преподавателя
     *
     * @return "Иванов И.И." или NULL
     */
    fun getTeacherName() = this.item.teacherName

    /**
     * Возвращает имя группы (для преподавателей)
     *
     * @return "ОИБТС-22-23" или NULL
     */
    fun getGroupName() = this.item.groupName

    /**
     * Возвращает номер пары
     *
     * @return "1" или "?"
     */
    fun getActualId() = this.item.actualId.replace("NULL", "?")

    /**
     * Возвращает дату
     *
     * //todo test only
     */
    fun debug_getDateTime() = this.item.dataAdded

}